import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { View } from "react-native";

export default class CommonTooltip extends React.Component {
  render() {
    const { title = "", icon: Icon, sx } = this.props;
    return (
      <View style={{ display: "inline-block", ...sx }}>
        <Tooltip
          title={title}
          interactive
          arrow
          TransitionProps={{
            style: { backgroundColor: "rgba(222,222,222,0.95)" },
          }}
        >
          <IconButton style={{ padding: 3 }}>
            <Icon />
          </IconButton>
        </Tooltip>
      </View>
    );
  }
}
